import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

interface EmailButtonProps {
  email: string | null | undefined;
  customerName?: string;
  orderNumber?: string;
}

export function EmailButton({ email, customerName, orderNumber }: EmailButtonProps) {
  const getMailtoLink = (): string => {
    if (!email) return "#";
    const subject = orderNumber ? `Tilaus ${orderNumber}` : customerName ? `Yhteydenotto - ${customerName}` : "Yhteydenotto";
    return `mailto:${email}?subject=${encodeURIComponent(subject)}`;
  };

  if (!email) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="ghost" size="icon" className="h-8 w-8 text-muted-foreground cursor-not-allowed opacity-50" disabled>
            <Mail className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent><p>Sähköpostia ei ole määritetty</p></TooltipContent>
      </Tooltip>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8 text-blue-600 hover:text-blue-700 hover:bg-blue-50" asChild>
          <a href={getMailtoLink()}><Mail className="h-4 w-4" /></a>
        </Button>
      </TooltipTrigger>
      <TooltipContent><p>{email}</p></TooltipContent>
    </Tooltip>
  );
}
